// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__213vj","bigColWidth":"Table_bigColWidth__14zBH","biggerColWidth":"Table_biggerColWidth__2UQv_","row":"Table_row__2bOA3","col":"Table_col__i-6oy"};